<ion-button *ngIf="!this.readonly" class="btn2 mt-1 mb-2 mr-1" (click)="AdjuntarArchivo()"><ion-icon name="add-circle-outline" class="mr-1"></ion-icon>Adjuntar archivo</ion-button>
<ion-button class="btn2 btnColorSecondary mt-1 mb-2 mr-2" (click)="sincronizarAdjuntos()"><ion-icon name="sync" class="mr-1"></ion-icon>Sincronizar</ion-button>
<div class="itemListTable" *ngIf="(adjuntosFiltrados | async) != null && HayAdjuntos(adjuntosFiltrados | async)">
  <ng-container *ngFor="let adjunto of adjuntosFiltrados | async">
    <ng-container *ngIf="(Categoria == null && adjunto.Categoria == null) || (adjunto.Categoria != null && adjunto.Categoria == Categoria)">
      <div class="textList">
        <span>{{adjunto.FileName}}</span>
        <div class="contentButton">
          <ion-button class="mr-2" color="primary" class="boxDelete" (click)="downloadAdjunto(adjunto)"><ion-icon name="arrow-down"  class="mr-0"></ion-icon></ion-button>
          <ion-button *ngIf="esPDF(adjunto)" class="mr-2" color="tertiary" class="boxDelete" (click)="editarPDF(adjunto)"><ion-icon name="pencil" class="mr-0"></ion-icon></ion-button>
          <ion-button *ngIf="!this.readonly" color="danger" class="boxDelete" (click)="EliminarAdjunto(adjunto)"><ion-icon name="trash" class="mr-0"></ion-icon></ion-button>
        </div>

        <ion-modal class="modalCustom modalEditarPDF" #mdlEditar (ionModalDidDismiss)="mdlEditar.isOpen = false">
          <ng-template>
            <ion-header>
              <ion-toolbar>
                <ion-buttons slot="end">
                  <ion-button (click)="mdlEditar.dismiss()"><ion-icon name="close"></ion-icon></ion-button>
                </ion-buttons>
                <ion-title>Editar</ion-title>
              </ion-toolbar>
            </ion-header>
            <ion-content>
              <div class="iframe-container" style="position: relative;">
                <iframe #iframePDF style="width: 100%; height: 100%;">
                </iframe>
              </div>
            </ion-content>
            <ion-footer>
              <ion-buttons slot="end" class="ml-auto">
                <ion-button (click)="guardarPDF(adjunto)" class="btn1 ml-auto"><ion-icon name="save" class="mr-2"></ion-icon>Guardar</ion-button>
              </ion-buttons>
            </ion-footer>
          </ng-template>
        </ion-modal>

      </div>
    </ng-container>
  </ng-container>
</div>
